

































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import ReportContainer from '@/modules/neodash/components/report-container/report-container.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import FilterContainer from '@/modules/neodash/components/filter-container/filter-container.vue';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import {NameValues, OptionalNameValue} from '../../model/types/interfaces/NameValue';
import {
    listAllMarketAnalysisReferences,
    listAllMarketSummaryPeriods
} from '../../model/constants/marketAnalysisDataSources';
import {FilterService} from '@/modules/neodash/services/filterService';
import _ from 'lodash';
import ReportVueContainer from '@/modules/neodash/components/report-vue-container/report-vue-container.vue';
import MarketSummaryReport from '@/modules/neodash/pages/marketSummary/market-summary.report.vue'
import {i18nMixin} from '../../mixins';

export interface Filter {
    period: OptionalNameValue,
    type: OptionalNameValue,
    locale: OptionalNameValue,
    marketShareReference: OptionalNameValue
}

@Component({
    name: 'MarketSummary',
    components: {
        ReportVueContainer,
        FilterDropDown,
        ReportContainer,
        PageLoader,
        FilterContainer,
        MarketSummaryReport
    },
})
export default class MarketSummary extends Vue {
    public readonly periodsDataSource: NameValues = listAllMarketSummaryPeriods();
    public localeTypesDataSource: NameValues = [];
    public locationsDataSource: NameValues = [];
    public marketShareReferenceDataSource = listAllMarketAnalysisReferences();
    private showMarketSummary = false;
    public readonly translate = i18nMixin.methods.i18n;
    public filterModel = {
        period: null,
        locale: null,
        marketShareReference: null,
        type: null
    } as Filter;

    public get formValid(): boolean {
        const {filterModel} = this;
        let formValid = !(_.isEmpty(filterModel));
        for (let member in filterModel) {
            if (!!filterModel[member])
                continue;
            formValid = false;
        }
        return formValid;
    }

    public showReport() {
        this.showMarketSummary = true;
    }

    public async created() {
        this.localeTypesDataSource = await FilterService.getTypeLocationsFromMarketAnalysis();
    }

    public async loadLoadLocations() {
        const {type} = this.filterModel;
        this.dataQuery.showMarketSummary = false;
        this.showMarketSummary = false;
        if (!type) {
            return;
        }
        this.locationsDataSource = await FilterService.getClientLocalesByType(type.value);
    }

    public get labels() {
        if(!this.showMarketSummary){
            return [];
        }
        const {translate} = this;
        const {period, marketShareReference, locale, type} = this.filterModel;

        const [labelPeriod, labelLocale, labelMarketShareReference, labelType] =
            ['Common.Period', 'Common.Locations', 'Common.MarketShareReference', 'Common.Type'].map(x => translate(x));

        const nameOrEmpty = (value: any) => (!!value ? value.name : '');

        return [
            {text: labelPeriod, value: nameOrEmpty(period)},
            {text: labelMarketShareReference, value: nameOrEmpty(marketShareReference)},
            {text: labelLocale, value: nameOrEmpty(locale)},
            {text: labelType, value: nameOrEmpty(type)},
        ]
    }

    public get dataQuery() {
        const textValue = (nameValue) => (!!nameValue ? {text: nameValue.name, value: nameValue.value} : {});
        const {type, period, locale, marketShareReference} = this.filterModel;
        return {
            type: textValue(type),
            location: textValue(locale),
            market_share_reference: textValue(marketShareReference),
            periodo: textValue(period),
            showMarketSummary: this.showMarketSummary
        }
    }
}
